var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        {
          ref: "popup",
          class: _vm.$.vgp_date_range_picker,
          style: Object.assign({}, _vm.position),
        },
        [
          _vm.showDateRangePresets
            ? _c(
                "div",
                { class: _vm.$.header },
                _vm._l(_vm.currentPresets, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: [
                        _vm.$.header__item,
                        _vm.currentPreset === item ? _vm.$.active : "",
                      ],
                      attrs: { "data-text": _vm.locales("datepiker_" + item) },
                      on: {
                        click: function ($event) {
                          return _vm.setPreset(item)
                        },
                      },
                    },
                    [
                      _c("span", { class: _vm.$.text }, [
                        _vm._v(_vm._s(_vm.locales("datepiker_" + item))),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _c("div", { style: { height: "10px" } }),
          _vm._v(" "),
          _c("vgp-date-picker", {
            ref: "calendar",
            attrs: {
              "is-range": _vm.isRange,
              "custom-selector": true,
              value: _vm.rangeValue.start,
              "range-value": _vm.rangeValue,
              columns: 2,
              "min-date": _vm.minDate,
              "max-date": _vm.maxDate,
              "has-default-slot": false,
              "has-footer-slot": false,
            },
            on: { onChange: _vm.onChange },
          }),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$.footer },
            [
              _c("vgp-button", {
                attrs: {
                  type: "primary",
                  small: true,
                  label: _vm.locales("common_done"),
                },
                on: { onClick: _vm.hidePicker },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }